import React, { useState } from 'react';
import styles from './styles';
import {Form, IconButton} from '../../../../';
import {btn_c_fadeToHighlight} from '../../../../styleGuide';
/**
 * Component for Message Input
 * @component
 * @param  {object} props Props for component
 * @example
 * <MessageInput sendNewMessage='FUNCTION'/>
 */
// const MessageInput = (props) => {
//   const [formState, setFormState] = useState('');
//   const handleSubmit = (e, state) => {
//     console.log(formState);
//     props.sendNewMessage({
//       to: props.patientId,
//       subject: props.subject,
//       message: state.message_input,
//       timeStamp: {
//         date: 'Jul 26, 2019',
//         time: '11:23 AM',
//       },
//     });
//     setFormState('');
//   };
//   const settings = [
//     {
//       type: 'textarea',
//       placeholder: 'Write a message...',
//       value: formState,
//       setter: (val) => setFormState(val.value),
//       id: 'message_input',
//       labelStyles: {
//         padding: '0 0 3px',
//         marginBottom: 0,
//       },
//       styles: {
//         height: '75px',
//       },
//       validators: ['fieldRequired'],
//       hideValidatorMessages: ['fieldRequired'],
//     },
//   ];
//
//   return (
//     <div style={styles.container}>
//       <Form
//         settings={settings}
//         handleSubmit={handleSubmit}
//       />
//     </div>
//   );
// };
//





const MessageInput = props => {

  const [input, setInput] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    if (input && input !== '') props.sendNewMessage({
      to: props.patientId,
      subject: props.subject,
      message: input,
    });
  }


  return(
    <form onSubmit={handleSubmit} style={styles.container}>
      <textarea
        id={props.id || 'messenger_input'}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => {if (e.keycode === 13) e.preventDefault();e.stopPropagation()}}
        style={styles.input}
        placeholder='Write your message here.'
      />
      <IconButton
        icon='send'
        size='sm'
        styles={styles.submit}
        preBuiltStyles={btn_c_fadeToHighlight}
      />
    </form>
  );
}



export default MessageInput;
